import * as React from "react"
import { SVGProps } from "react"

const Bin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 7.5a.75.75 0 0 1 .75.75V12a.75.75 0 0 1-1.5 0V8.25a.75.75 0 0 1 .75-.75ZM10.5 7.5a.75.75 0 0 1 .75.75V12a.75.75 0 0 1-1.5 0V8.25a.75.75 0 0 1 .75-.75Z"
      fill="#F35C8A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 1.5a2.25 2.25 0 0 0-2.25 2.25h-3a.75.75 0 0 0 0 1.5H3v9a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 15 14.25v-9h.75a.75.75 0 0 0 0-1.5h-3A2.25 2.25 0 0 0 10.5 1.5h-3Zm3.75 2.25A.75.75 0 0 0 10.5 3h-3a.75.75 0 0 0-.75.75h4.5Zm-6 1.5H4.5v9c0 .414.336.75.75.75h7.5a.75.75 0 0 0 .75-.75v-9H5.25Z"
      fill="#F35C8A"
    />
  </svg>
)

export default Bin
